import React from 'react';
import OverriddenDatePicker from './OverriddenDatePicker';

const TimePicker = props => <OverriddenDatePicker {...props} picker="time" mode={undefined} />;
TimePicker.displayName = 'TimePicker';

export default TimePicker;
